<template>
    <div>
        <x-table-server ref="refStoreTableServer"
                        :title="title"
                        :resource="resource"
                        :show-filter="true"
                        :show-button-export="false"
                        :show-button-new="true"
                        :reload-table-server.sync="reloadTableServer"
                        @click-create="clickCreate()">
            <template v-slot:table-rows="props">
                <tr v-for="row in props.records">
                    <td v-for="col in props.columns" :class="col.class_col_body" :key="col['name']">
                        <template v-if="col['name'] === 'actions'">
                            <x-button-icon icon="fa-light fa-pencil"
                                           class="x-button-icon-small"
                                           @click="clickCreate(row.id)"></x-button-icon>
                            <x-button-icon icon="fa-light fa-trash"
                                           class="x-button-icon-small"
                                           @click="clickDelete(row)"></x-button-icon>
                        </template>
                        <template v-else-if="col['name'] === 'lines'">
                            <el-tag v-for="l in row.lines" :key="l.id">{{ l.label }}</el-tag>
                        </template>
                        <template v-else>
                            {{ row[col['name']] }}
                        </template>
                    </td>
                </tr>
            </template>
        </x-table-server>

        <shipping-type-form :show-dialog.sync="showDialogForm"
                            :record-id="recordId"
                            :resource="resource"
                            @success="reloadTableServer = true"></shipping-type-form>

        <x-dialog-delete :show-dialog.sync="showDialogDelete"
                         :resource="resource"
                         :record-id="recordId"
                         @success="reloadTableServer = true"></x-dialog-delete>
    </div>
</template>

<script>

import XTableServer from "../../../../components/Form/XTableServer.vue";
import ShippingTypeForm from "./Form.vue";
import XButtonPrimary from "../../../../components/Form/XButtonPrimary.vue";
import XButtonDownload from "../../../../components/Form/XButtonDownload.vue";
import XButtonIcon from "../../../../components/Form/XButtonIcon.vue";
import XDialogDelete from "../../../../components/Form/XDialogDelete.vue";

export default {
    name: 'ShippingTypeIndex',
    components: {
        XDialogDelete,
        XButtonIcon, XButtonDownload, XButtonPrimary, ShippingTypeForm, XTableServer
    },
    data() {
        return {
            title: 'Tipos de envío',
            resource: 'shipping_types',
            recordId: null,
            showDialogForm: false,
            showDialogDelete: false,
            reloadTableServer: false,
        }
    },
    methods: {
        clickCreate(id = null) {
            this.recordId = id;
            this.showDialogForm = true;
        },
        clickDelete(row) {
            this.recordId = row.id;
            this.showDialogDelete = true;
        },
    }
}
</script>
